// Decides the onboarding the new account gets on its first sign-in
import {
  useCallback,
  useEffect,
} from 'react';

import {
  Column,
  RadioButton,
  useWizardContext,
} from '../../../components';
import { useTownAssets } from '../../../stores';

const teamSetups = ['solo', 'small', 'large'];

const teamSetupTlKey = (value) => `teamSetup${value.charAt(0).toUpperCase()}${value.slice(1)}`;

const pageStateValidator = (state) => {
  const valid = { teamSetup: teamSetups.includes(state.teamSetup) };

  return { valid, errors: {}, pageValid: valid.teamSetup };
};

function InviteAckTeamSizePage() {
  const { assets } = useTownAssets();
  const { translate } = assets;
  const {
    setPageInfo,
    setPageState,
    state,
  } = useWizardContext();

  const handleChange = useCallback(
    (event) => { setPageState({ teamSetup: event.currentTarget.id }); },
    [setPageState],
  );

  useEffect(
    () => {
      setPageInfo({
        prevPage: 'team',
        nextPage: 'confirm',
        pageStateValidator,
      });
    },
    [setPageInfo],
  );

  return (
    <Column crossStretch gap={4} className="flex-1 min-h-0 w-full overflow-y-auto p-2">
      <span className="px-2 mb-2 text-center">
        {translate('teamSetupQuestion', 'statements')}
      </span>

      {teamSetups.map((option) => (
        <Column key={option} crossStart gap={0}>
          <RadioButton
            id={option}
            name="teamSetup"
            label={translate(teamSetupTlKey(option), 'statements')}
            onChange={handleChange}
            selected={state.teamSetup === option}
            className="font-semibold"
          />
          <span className="ml-9 -mt-1 mb-2 italic text-sm text-pxTxtMuted">
            {translate(`${teamSetupTlKey(option)}Desc`, 'statements')}
          </span>
        </Column>
      ))}
    </Column>
  );
}

export default InviteAckTeamSizePage;
